import { SellingColumn } from "./data/selling";
import { SellingStage } from "./enums/selling";

export default function normalizeKanbanColumns(columnsFromDb: SellingColumn[]) {
    const allStages = Object.values(SellingStage);

    return allStages.map((stage) => {
        const existing = columnsFromDb.find((c) => c.title === stage);
        return existing || { title: stage, items: [] };
    });
}